import { memo, useMemo } from 'react'

import { IContact } from 'clickNgo/entities/contact'
import { IContactFlags } from 'clickNgo/entities/contactFlag'
import { ModalDialog } from 'core-components/library/modalDialog'

import { ContactDeactivationModalContent } from './ContactDeactivationModalContent'
import { BackupProvider, ContactDataContext, ReassignmentProvider } from './contexts'

import styles from './ContactDeactivationModal.module.scss'

type Props = {
  contact: IContact
  contactFlags: IContactFlags
  isVisible: boolean
  onDeactivate: (deactivatedContact: IContact) => void
  onClose: () => void
}

export const ContactDeactivationModal = memo<Props>(
  ({ contact, contactFlags, isVisible, onClose, onDeactivate }) => {
    const contactDataValue = useMemo(
      () => ({
        contact,
        contactFlags,
      }),
      [contact, contactFlags]
    )

    return (
      <ContactDataContext.Provider value={contactDataValue}>
        <ReassignmentProvider>
          <BackupProvider>
            <ModalDialog
              classes={styles}
              show={isVisible}
              content={() => (
                <div className={styles.content}>
                  <ContactDeactivationModalContent onClose={onClose} onDeactivate={onDeactivate} />
                </div>
              )}
              onClose={onClose}
              size="sm"
            />
          </BackupProvider>
        </ReassignmentProvider>
      </ContactDataContext.Provider>
    )
  }
)

ContactDeactivationModal.displayName = 'ContactDeactivationModal'
